import { useState } from 'react';
import { Menu, X } from 'lucide-react';

import ImageWithFallback from './ImageWithFallback';
import * as S from './styles';

interface Props {
  logoUrl?: string;
  logoAlt: string;
}

function Header({ logoUrl, logoAlt }: Props) {
  const [menuAberto, setMenuAberto] = useState(false);

  return (
    <S.HeaderBar>
      <S.HeaderInner>
        <S.HeaderLogo as={ImageWithFallback} src={logoUrl} alt={logoAlt} />

        <S.HeaderCta href="#contato">Fale Conosco</S.HeaderCta>

        <S.MenuToggle onClick={() => setMenuAberto(!menuAberto)} aria-label="Abrir menu">
          {menuAberto ? <X size={24} /> : <Menu size={24} />}
        </S.MenuToggle>
      </S.HeaderInner>

      {menuAberto && (
        <S.MobileNav>
          <S.MobileCta href="#contato" onClick={() => setMenuAberto(false)}>
            Fale Conosco
          </S.MobileCta>
        </S.MobileNav>
      )}
    </S.HeaderBar>
  );
}

export default Header;
